// @flow

import React from 'react';

import {gt} from 'app/utils/i18n';

import {BaseTour, tooltipTitleStyles, TourStep} from './BaseTour';

const steps: Array<TourStep> = [
  {
    role: 'any',
    title: gt('Welcome to SweetProcess!'),
    content: gt(
      "This is a quick tour to show you around your Dashboard, the place where you'll manage all of your documents."
    ),
    placement: 'center',
    target: 'body',
  },
  {
    role: 'manager',
    title: gt('All your documents'),
    content: gt(
      "Here is your list of all your documents. If this is your first time here, you'll notice we've already created one procedure for you."
    ),
    target: '.tour-documents-list',
  },
  {
    role: 'teammate',
    title: gt('All your documents'),
    content: gt(
      'Here is your list of all your documents. Any documents that you have been given access to will appear here.'
    ),
    target: '.tour-documents-list',
  },
  {
    role: 'manager',
    title: gt('Create a New Document'),
    content: gt(
      "When you're ready to create a new document, click this button."
    ),
    target: '.tour-create-button',
  },
  {
    role: 'any',
    title: gt('Edit a Document'),
    content: gt(
      "To edit one of your documents, select the 'Edit' button from the menu on each document."
    ),
    target: '.tour-document-item .js-edit-dropdown',
  },
  {
    role: 'manager',
    title: gt('Systemize your Business'),
    content: gt(
      'You can assign once off or recurring tasks to employees or yourself and track them in your Tasks dashboard.'
    ),
    target: '.navbar-nav .nav-item.tasks',
    highlight: '.navbar-nav .nav-item.tasks',
  },
  {
    role: 'manager',
    title: gt("That's all for now..."),
    content: (
      <div>
        {gt('This concludes your tour of the dashboard.')}
        <h4 className="mt-4 mb-3" style={tooltipTitleStyles}>
          {gt('Where to from here?')}
        </h4>
        {gt(
          "You can go ahead and create a new document, or edit the one we've created for you."
        )}
      </div>
    ),
    placement: 'center',
    target: 'body',
  },
  {
    role: 'teammate',
    title: gt("That's all for now..."),
    content: (
      <div>
        {gt('This concludes your tour of the dashboard.')}
        <h4 className="my-2" style={tooltipTitleStyles}>
          {gt('Where to from here?')}
        </h4>
        {gt(
          "You can go ahead and comment on a document, or edit the one we've created for you."
        )}
      </div>
    ),
    placement: 'center',
    target: 'body',
  },
];

export const DashboardTour = (): JSX.Element => (
  <BaseTour tourname="dashboard" steps={steps} />
);
